import $ from 'jquery';
import ahoy from "ahoy.js";

$(() => {
  const techniqueTitle = $('#technique').data('technique-title');

  ahoy.configure({
    urlPrefix: "",
    visitsUrl: "/ahoy/visits",
    eventsUrl: "/ahoy/events",
    page: techniqueTitle,
    platform: "Web",
    useBeacon: true,
    startOnReady: true,
    trackVisits: true,
    cookies: true,
    cookieDomain: null,
    headers: {},
    visitParams: {},
    withCredentials: false
  });

  $('.category-name').on('click', function(){
    ahoy.track($(this).data('section'), { technique_title: techniqueTitle })
  });

});